// React
import React, { useState, useEffect, useRef } from "react";

// Ionic
import {
  IonList,
  IonLabel,
  IonItem,
  IonInput,
  IonContent,
  IonButton,
  IonItemDivider,
  IonCheckbox,
  IonModal,
} from "@ionic/react";
import userService from "../Context/user.service";

function ModalBookmark(probs) {
  const [showModal, setShowModal] = useState(false);
  const [bookmarkList, setBookmarkList] = useState(probs.bookmark.lists);
  const [rendered, setRendered] = useState(true);

  const [bookmarkModalList, setBookmarkModalList] = useState([]);

  window.bookmarkList2 = probs.bookmark.lists;
  useEffect(() => {}, []);

  function onWillDismiss() {
    setShowModal(false);
  }

  function handlebookmark() {
    if (probs.isProValue === true) {
      setShowModal(true);
      prepareBookmarkList();
    } else {
      if (typeof window.parent.setPaywallModal !== "undefined") {
        window.parent.setPaywallModal("pro");
      }

      return false;
    }
  }

  function save_bookmark(toendpoint) {
    var curid = window.openid;
    var lists = document.querySelectorAll("[data-type='list']");
    var isInAnyList = false;
    // compare rendered dom with bookmarks
    lists.forEach((list) => {
      var isInList = false;

      window.bookmarkList2.forEach((blist, index) => {
        if (blist.name === list.getAttribute("name")) {
          isInList = true;

          if (list.checked === true) {
            isInAnyList = true;
            if (
              window.bookmarkList2[index].items.indexOf(curid) === -1 &&
              curid != 0
            ) {
              window.bookmarkList2[index].items.push(curid);
            }
          } else {
            if (blist.items.indexOf(curid) !== -1) {
              window.bookmarkList2[index].items.splice(
                blist.items.indexOf(curid),
                1
              );
            }
          }
        }
      });
      if (isInList === false) {
        if (list.checked === true && curid != 0) {
          window.bookmarkList2.push({
            name: list.getAttribute("name"),
            items: [curid],
          });
        } else {
          window.bookmarkList2.push({
            name: list.getAttribute("name"),
            items: [],
          });
        }
      }
    });
    window.isInAnyList = isInAnyList;
    var data = { pid: probs.pid * 1, lists: window.bookmarkList2 };

    // save data to endpoint
    if (toendpoint) {
      userService
        .saveBookmarks(data, probs.pid, probs.token)
        .then((response) => {
          if (window.isInAnyList === false) {
            document
              .querySelector("[data-icon-id='" + curid + "']")
              .setAttribute("data-fav", false);
          } else {
            document
              .querySelector("[data-icon-id='" + curid + "']")
              .setAttribute("data-fav", true);
          }
          setShowModal(false);
        })
        .catch((err) => {});
    }
  }

  function prepareBookmarkList() {
    const bookmarkModalListPrepare = [];
    var curid = window.openid;

    probs.bookmark.lists.forEach((item) => {
      var itemIn = false;
      item.items.forEach((id) => {
        if (curid === id) {
          itemIn = true;
        }
      });
      var newitem = { name: item.name, checked: itemIn };
      bookmarkModalListPrepare.push(newitem);
    });
    setBookmarkModalList(bookmarkModalListPrepare);

  }

  function addItemList() {
    var newlist = bookmarkModalList;
    var newitem = {
      name: document.querySelector("#newlist input").value,
      checked: true,
    };
    newlist.push(newitem);
    setBookmarkModalList(newlist);

    var saveBookmark = bookmarkList;
    setBookmarkList(null);
    setTimeout(function () {
      setBookmarkList(saveBookmark);
    }, 100);
  }

  return (
    <>
      <IonContent id="modalBookmark">
        <IonModal
          isOpen={showModal}
          className="wrapper__bookmark"
          onWillDismiss={() => onWillDismiss()}
        >
          <h4>Zur Merkliste hinzufügen</h4>
          <IonList>
            {probs.bookmark !== "undefined" &&
              probs.bookmark.length !== 0 &&
              bookmarkModalList.map((item, index) => {
                return rendered ? (
                  <IonItem key={item.name} className="filter__item__accordion">
                    <IonCheckbox
                      checked={item.checked}
                      id={item.name}
                      name={item.name}
                      value={item.name}
                      data-type="list"
                    ></IonCheckbox>
                    <IonLabel className="ion-padding-start">
                      <p className="font__small font__accordion">{item.name}</p>
                    </IonLabel>
                  </IonItem>
                ) : (
                  <></>
                );
              })}

            <IonItemDivider></IonItemDivider>
            <IonItem>
              <IonInput
                id="newlist"
                value=""
                placeholder="Neue Liste"
              ></IonInput>
              <IonButton onClick={() => addItemList()} color="primary">
                Hinzufügen
              </IonButton>
            </IonItem>
          </IonList>
          <div className="modalbookmark__button__wrapper">
            <IonButton
              onClick={() => save_bookmark(true)}
              expand="block"
              shape="round"
              className="modalbookmark__button"
            >
              Speichern
            </IonButton>
            <IonButton
              onClick={() => setShowModal(false)}
              expand="block"
              shape="round"
              className="modalbookmark__button"
            >
              Abbrechen
            </IonButton>
          </div>
        </IonModal>
        <IonButton data-id="0" id="openmodal" onClick={() => handlebookmark()}>
          Show Modal
        </IonButton>
      </IonContent>
    </>
  );
}

export default ModalBookmark;
